import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authSlice from "./slices/authSlice.js";
import AdminSlice from "./slices/adminSlice.js";
import ServicesSlice from "./slices/servicesSlice.js";
import AppointmentSlice from "./slices/appointmentSlice.js";
import SettingsSlice from "./slices/settingsSlice.js";


const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

const rootReducer = combineReducers({
  auth: authSlice,
  admin: AdminSlice,
  services : ServicesSlice,
  appointment : AppointmentSlice,
  settings : SettingsSlice
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);
